
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3 4.84A1.84 1.84 0 014.842 3h14.316A1.84 1.84 0 0121 4.84v11.884a1.84 1.84 0 01-1.842 1.84h-1.005a.74.74 0 110-1.48h1.005a.36.36 0 00.36-.36V4.84a.36.36 0 00-.36-.359H4.842a.36.36 0 00-.36.36v11.883c0 .198.161.36.36.36h1.752a.74.74 0 110 1.48H4.842A1.84 1.84 0 013 16.724V4.84zm3.587 1.801a.742.742 0 011.048-.02l1.45 1.396a.74.74 0 010 1.067l-1.45 1.396a.742.742 0 01-1.028-1.067l.896-.862-.896-.863a.74.74 0 01-.02-1.047zm3.612 3.28a.74.74 0 01.741-.741h2.851a.74.74 0 110 1.48h-2.85a.74.74 0 01-.742-.74zm.348 4.938a.105.105 0 00-.157.09v4.463c0 .08.087.13.157.09l3.868-2.23c.07-.041.07-.142 0-.182l-3.868-2.231zm-1.639.09c0-1.22 1.322-1.983 2.38-1.373l3.868 2.231a1.585 1.585 0 010 2.747l-3.868 2.231c-1.058.61-2.38-.152-2.38-1.373v-4.463z","fill":"#202D38"}})])
          )
        }
      }
    